module.exports = __webpack_public_path__ + "static/img/1_1_6_3.67990518.jpg";